import { useState } from "react";

export interface State<T> {
    readonly value: T;
    set(value: T): void;
}

export function useState2<T>(initialStateFunc: () => T): State<T>;
export function useState2<T>(initialState: T): State<T>;
export function useState2<T = undefined>(): State<T | undefined>;
export function useState2<T>(initialState: T | (() => T) = undefined as any): State<T> {
    const [s, setS] = useState<T>(initialState);
    return {
        value: s,
        set: setS
    };
}
